import type { Drug } from "../types";

export const clarithromycinDrug: Drug = {
  id: "clarithromycin",
  name: "Clarithromycin",
  drugClass: "macrolide",
  defaultFoodTiming: "Take with or without food",
  swallowingNote: "Tablets should be swallowed whole with water",
  liquidTasteNote:
    "Clarithromycin oral suspension can cause a bitter after-taste. This can be avoided by drinking juice or water soon after intake.",
  paediatricLinkRefs: [
    "medicines-for-children-clari",
    "medicines-for-children-giving-tablets",
  ],
  formulations: [
    {
      id: "clari-250-tab",
      type: "tablet_ir",
      strength: 250,
      strengthUnit: "mg",
      prescribedItemId: "26bbcd34-8985-43e8-919f-e2b70cc8b27e",
    },
    {
      id: "clari-500-tab",
      type: "tablet_ir",
      strength: 500,
      strengthUnit: "mg",
      prescribedItemId: "38e5f3e3-e7e8-4508-b7b0-c148dd20392e",
    },
    {
      id: "clari-125-5ml",
      type: "oral_suspension",
      strength: 125,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 70,
      bottleSizeUnit: "mL",
      prescribedItemId: "c2a1644c-8bae-4dea-8920-fe7695853520",
    },
    {
      id: "clari-250-5ml",
      type: "oral_suspension",
      strength: 250,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 70,
      bottleSizeUnit: "mL",
      prescribedItemId: "f50fb9cd-a562-4d04-837a-dd41a4e024c4",
    },
  ],
};
